(ns frontend.view.settings.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce state (r/cursor app-db/views [:settings]))
